<div class="opleiding-rooster">
  <div *ngFor="let opleiding of opleidingen">
    <app-opleiding-card
      (preview)="handlePreview($event)"
      (select)="handleSelect($event)"
      (favorite)="handleFavoriteClick($event)"
      [mode]="mode"
      [opleiding]="opleiding"
    >
    </app-opleiding-card>
  </div>
  <div
    class="loading-card"
    *ngIf="loading && mode === OpleidingCardEnum.DEFAULT"
  >
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</div>
